import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { USerIdentificationForm } from "../../model/user_identification_model/user_identification_model";
import { Label } from "@mui/icons-material";
import { getSurveyorDetails } from "../../../../services/survey_services/survey_services";

function UserIdentification(props: USerIdentificationForm) {
  const [surveyorDetails, setSurveyorDetails] = useState<any>(null);
  const {
    address,
    deaneryName,
    parishName,
    pincode,
    setAddress,
    setDeaneryName,
    setParishName,
    setPincode,
    setSurveyCode,
    surveyCode,
    setSurveyStep,
    surveyStep,
  } = props;

  useEffect(() => {
    if (surveyCode.length === 12) getSurveyorDetailsById(surveyCode);
  }, [surveyCode]);

  function getSurveyorDetailsById(surveyId: string) {
    getSurveyorDetails(surveyId)
      .then((res:any) => {
        setDeaneryName(res?.data?.deaneryName);
        setParishName(res?.data?.parishName);
        setSurveyorDetails(res?.data);
      })
      .catch((e: any) => {
        setSurveyorDetails(null);
      });
  }

  return (
    <Box mt={1}>
      <Box>
        <Typography fontWeight={600} variant="h5">
          User Identification
        </Typography>
      </Box>
      <Grid container mt={1} spacing={4}>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            1. Survey Code<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            sx={{ mt: 1 }}
            onChange={(e) => {
              const input = e.target.value;
              if (input.length <= 12) {
                setSurveyCode(input);
                setParishName("");
                setDeaneryName("");
              }
            }}
            value={surveyCode}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            2. Deanery Name<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField fullWidth sx={{ mt: 1 }} value={deaneryName} />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            2. Parish Name<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField fullWidth sx={{ mt: 1 }} value={parishName} />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            3. Address<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={6}
            sx={{ mt: 1 }}
            onChange={(e) => setAddress(e.target.value)}
            value={address}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={12} lg={12} xl={12}>
          <Typography variant="subtitle1" fontWeight={500}>
            5. Pincode<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            sx={{ mt: 1 }}
            onChange={(e) => {
              const regex = /^[0-9]{0,6}$/;
              if (e.target.value === "") {
                setPincode("");
              } else if (e.target.value.length <= 6) {
                if (regex.test(e.target.value)) {
                  setPincode(+e.target.value);
                }
              }
            }}
            value={pincode}
            InputProps={{
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
              },

              sx: {
                "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                  {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                "& input[type=number]": {
                  MozAppearance: "textfield", // Firefox
                },
              },
            }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              maxLength: 6,
            }}
          />
        </Grid>
        <Grid item sm={6} xs={6} md={3} lg={3} xl={3}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={() => {
              setSurveyStep(surveyStep + 1);
            }}
            disabled={
              !parishName ||
              !deaneryName ||
              !address ||
              pincode.toString().length !== 6
            }
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default UserIdentification;
